import { IPatientSearchSchema } from "./calendar";
import { IPatientSchema } from "./patient";

export type IDispense = {
  id: number;
  dispense: string;
  name: string;
  email: string;
  status: DispenseOrderStatus;
  number: number;
  orderId: number;
  phone: number;
  patientId: number | string;
  axisId?: number;
  refractionId?: number;
  handoverNotes?: string;
  isExternal: boolean;
  voucherId: number;
  addonId: number;
  orderingNotes: string;
  totalPrice: number;
  patient: IPatientSchema; // contains firstName, date_of_birth, etc.
  specType?: string;
  pdRight?: number;
  pdLeft?: number;
  heightRight?: number;
  heightLeft?: number;
  bvd?: number;
  pantoscopicTilt?: number;
  wrapAngle?: number;
  pickupDateTime?: string;
  adjustedPrice?: number;
  discount?: number;
};

export type Dispense = {
  id: number;
  patientId: string;
  patientName: string;
  patientDOB: Date;
  lastDispenseStatus: DispenseOrderStatus;
  totalDispenses: number;
};

export type IDispenseRecordSchema = { type: string; date: Date };

export type IDispenseRequest = {
  specType: string;
  status: string; // restricts to allowed values
  type: string;
  patientId: number | string | null; // instead of `any`
  vouchers: any; // can refine later
  addons: any; // can refine later
  framesAndLenses: IFramesAndLenses[];
  orderingNotes?: string;
  handoverNotes?: string;
  sourceType?: string;
  sourceId?: number;
  pdRight?: number | null;
  pdLeft?: number | null;
  heightRight?: number | null;
  heightLeft?: number | null;
  bvd?: number | null;
  pantoscopicTilt?: number | null;
  wrapAngle?: number | null;
  pickupDateTime?: string;
  patient: IPatientSearchSchema;
  adjustedPrice?: number;
  totalPrice?: number;
  discount?: number;
  hobbies?: string;
  isVDU?: boolean,
  isSmoker?: boolean,
  isDriver?: boolean,
  isExternal?: boolean,
};

export type IFramesAndLenses = {
  productId?: number;
  category: string;
  quantity: number;
  price: number;
  type: string;
  name: string;
  code: string;
  differentRL: boolean;
  rLens?: string;
  lLens?: string;
};

export type IDispenseRequestFromHandover = {
  status: string;
  axisId: number;
  refractionId: number;
  handoverId: number;
  clinicalRecordId: number;
};

export type statusOptionsProps = {
  label: string;
  value: DispenseOrderStatus;
};

export type IRepairPart = {
  id: string;
  sku: string;
  description: string;
  stockQty: number;
  price: number;
};

export type IRepairPartItem = {
  partId: string;
  quantity: number;
};

export type IRepairOrderRequest = {
  patientId: string | number;
  originalDispenseId?: number;
  repairType: string;
  parts: IRepairPartItem[];
  warranty: boolean;
};

export type IRepairOrder = {
  id: string;
  patientId: string | number;
  originalDispenseId?: number;
  repairType: string;
  partsSummary: string;
  cost: number;
  warranty: boolean;
  createdByUser?: any;
  createdDate: string;
  patient?: IPatientSchema;
  originalDispense?: IDispense;
};

export enum DispenseOrderStatus {
  DRAFT = "draft",
  UNCANCELLED = "uncancelled",
  UNPROCESSED = "unprocessed",
  OUTSTANDING = "outstanding",
  OVERDUE = "overdue",
  UNCOLLECTED = "uncollected",
}
